import { useEffect, useState } from 'react';
import { AppModal } from '../AppModal';
import { AvatarPicker, type IAvatarItem, type IAvatarValue } from './AvatarPicker';

type AvatarPhotoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  value: IAvatarValue;
  avatarList: IAvatarItem[];
  onApply: (avatar: IAvatarValue) => void;
};

export function AvatarPhotoModal({
  isOpen,
  onClose,
  title,
  value,
  avatarList,
  onApply,
}: AvatarPhotoModalProps) {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    if (!isOpen) return;
    setDraft(value);
  }, [isOpen, value]);

  const fallback = avatarList[0];

  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      title={title}
      applyTitle="common.confirm"
      onApply={() => {
        onApply({ ...draft, confirmed: true });
        onClose();
      }}
      size="lg"
    >
      <AvatarPicker
        value={draft}
        avatarList={avatarList}
        outputMode="file"
        showConfirm={false}
        onChange={setDraft}
        onRemove={() => {
          if (!fallback) return;
          setDraft({ src: fallback.src, type: 'avatar', confirmed: true });
        }}
      />
    </AppModal>
  );
}
